export const getClassByAttrName = <AttrClassList>(
  obj: AttrClassList,
  types?: Array<keyof AttrClassList>,
) =>
  types
    ? types.reduce((classString, type) => {
        return `${classString} ${obj[type]}`;
      }, "")
    : "";
